import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Margin } from 'styled-components-spacing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'i18n';
import Checkbox from 'components/inputs/Checkbox/CheckboxComponent';

function SearchTriggerToggleComponent({
  mapWasMoved,
  onlyHotelsOnMap,
  onClickRedoSearchHere,
  onClickOnlyHotelsOnMapCheckbox,
}) {
  return (
    <Fragment>
      {mapWasMoved ? (
        <RedoSearchHere onClick={onClickRedoSearchHere}>
          <FormattedMessage
            id='searchResultsMap.redoSearchHere.label'
            description='Redo search here'
            defaultMessage='Redo search here'
            tagName={'span'}
          />
          <Margin right='0.5' inline />
          <FontAwesomeIcon icon='redo' />
        </RedoSearchHere>
      ) : (
        <OnlyHotelsOnMapCheckbox>
          <Checkbox onChange={onClickOnlyHotelsOnMapCheckbox} isChecked={onlyHotelsOnMap} />
          <Margin right='0.5' inline />
          <FormattedMessage
            id='searchResultsMap.checkbox.onlyHotelsOnMap.label'
            description='Search as i move the map'
            defaultMessage='Search as i move the map'
            tagName={'span'}
          />
        </OnlyHotelsOnMapCheckbox>
      )}
    </Fragment>
  );
}

export default SearchTriggerToggleComponent;

const RedoSearchHere = styled.button`
  position: absolute;
  top: 10px;
  left: 53px;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.adjacent.default};
  border-radius: 4px;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);

  border: none;
  font-size: unset;
  color: white;
  cursor: pointer;

  span {
    font-size: 1.6em;
    vertical-align: middle;
  }

  svg {
    font-size: 1.6em;
    vertical-align: bottom;
    color: white;
  }
`;

const OnlyHotelsOnMapCheckbox = styled.div`
  position: absolute;
  top: 10px;
  left: 53px;
  padding: 8px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);

  span {
    font-size: 1.6em;
    vertical-align: middle;
  }
`;
